import React from 'react';
import {
  Button,
  Transition,
  Grid,
  Form,
  Header
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";

class ComingSoon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.closeAvailabilityModal = this.closeAvailabilityModal.bind(this);
  }

  closeAvailabilityModal(e) {

  }

  continue() {
    var offset = document.body.scrollTop;
    document.body.style.top = (offset * -1) + 'px';
    document.body.classList.add('modal--opened');
    // this.setState({
    //   animation: "fade right",
    //   visible: false
    // });

    setTimeout(() => {
      this.props.history.push('/check');
    }, 400);
  }

  transitionBack() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(9, "fade right")
    }, 400);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
  }

  componentWillUnmount() {
    this.closeAvailabilityModal();
  }
  render() {
    const { visible, animation } = this.state;
    return <div>
      <div className="back--icon" onClick={this.transitionBack} />
      <Transition visible={visible} duration={500} animation={animation}>
        <div className="building-form">
          <Header className="title__main" as="h1" textAlign="center">
            Coming Soon
          </Header>
          <Header.Subheader className="text-black">
            Service is coming soon to your building.
          </Header.Subheader>
          <Form className="form check-address">
            <Grid className="mx-0 my-0">
              <Button className='btn--full' type="button" size='medium' onClick={this.continue.bind(this)}>Get Notified</Button>
            </Grid>
          </Form>
        </div>
      </Transition>
    </div>
  };
}

export default withRouter(ComingSoon);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/ComingSoon.js